module.exports = __webpack_public_path__ + "assets/6580768f442338bedee0c4d5ea2d02ed.png";